export default "__VITE_ASSET__DRjS4Xmi__"